<button color="primary" mat-mini-fab>
  @if (!(showIsDoneIcon$ | async)) {
    <mat-icon>
      <ng-content></ng-content>
    </mat-icon>
  } @else {
    <mat-icon class="success-icon">done</mat-icon>
  }
  @if (isLoading$ | async) {
    <mat-progress-spinner
      [diameter]="40"
      [strokeWidth]="1"
      mode="indeterminate"
    ></mat-progress-spinner>
  }
</button>
